import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import 'react';

const MediumFilter = ({ testId, className, solid })=>{
    return /*#__PURE__*/ jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "data-testid": testId,
        className: className,
        children: solid ? /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("path", {
                    d: "M7.30005 3.99999C7.30005 2.50882 8.50888 1.29999 10 1.29999C11.4912 1.29999 12.7 2.50882 12.7 3.99999C12.7 5.49116 11.4912 6.69999 10 6.69999C8.50888 6.69999 7.30005 5.49116 7.30005 3.99999Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M15 4.69999L12 4.69999L12 3.29999L15 3.29999L15 4.69999Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8 4.69999L1 4.69999L1 3.29999L8 3.29999V4.69999Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8.69995 12C8.69995 13.4912 7.49112 14.7 5.99995 14.7C4.50878 14.7 3.29995 13.4912 3.29995 12C3.29995 10.5088 4.50878 9.30001 5.99995 9.30001C7.49112 9.30001 8.69995 10.5088 8.69995 12Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M1 11.3H4V12.7H1V11.3Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ jsx("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M8 11.3L15 11.3L15 12.7L8 12.7L8 11.3Z",
                    fill: "currentColor"
                })
            ]
        }) : /*#__PURE__*/ jsxs(Fragment, {
            children: [
                /*#__PURE__*/ jsx("circle", {
                    cx: "10",
                    cy: "4",
                    r: "2",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M12 4L15 4",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M1 4L8 4",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("circle", {
                    cx: "6",
                    cy: "12",
                    r: "2",
                    transform: "rotate(-180 6 12)",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M4 12H1",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                }),
                /*#__PURE__*/ jsx("path", {
                    d: "M15 12L8 12",
                    stroke: "currentColor",
                    strokeWidth: "1.4"
                })
            ]
        })
    });
};

export { MediumFilter as default };
